import type { PaymentMethod } from '@avalara/types/biztech';

export const paymentMethodTitle = (paymentMethod: PaymentMethod): string => {
  if (paymentMethod.Type === 'NewCreditCard') return 'New credit card';

  const { mask, type } = (() => {
    switch (paymentMethod.Type) {
      case 'CreditCard':
      case 'CreditCardReferenceTransaction':
      case 'Credit Card':
      case 'Debit Card':
        return {
          mask: paymentMethod.CreditCardMaskNumber,
          type: paymentMethod.CreditCardType,
        };
      case 'ACH':
        return {
          mask: paymentMethod.AchAccountNumberMask,
          type: 'Bank account',
        };
      default:
        // Note(Andrew) this *should* never be reached
        return {
          mask: 'XXXX',
          type: 'Payment method',
        };
    }
  })();
  return `${type} ending in ${mask.substr(mask.length - 4)}`;
};
